import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';

import { rem } from '../../helpers';

export const $Row = styled.div`
  display: flex;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.newUI.dividerColors.default};
    margin-bottom: ${rem(32)};
    padding-bottom: ${rem(32)};
  }
  &:last-child {
    padding-bottom: 0;
  }

  @media ${media.maxWidth.sm} {
    flex-direction: column;
  }
`;

export const $TitleCol = styled.div`
  color: ${({ theme }) => theme.newUI.defaultColors.text};
  font-weight: 700;
  line-height: 18px;
  width: 10%;

  @media ${media.maxWidth.sm} {
    width: 100%;
    margin-bottom: 0.5rem;
  }
`;

export const $ContentCol = styled.div<{ $fluid?: boolean }>`
  width: ${({ $fluid }) => ($fluid ? '90%' : '80%')};
`;
